export class Queue {
    constructor(executor) {
        this.items = [];
        this.executing = false;
        this.executor = executor;
    }
    queue(...params) {
        const result = new Promise((fulfill) => {
            const action = () => this.executor(...params).then((result) => {
                fulfill(result);
                return result;
            });
            this.items.unshift(action);
        });
        this.execute();
        return result;
    }
    execute() {
        if (this.executing) {
            return;
        }
        const action = this.items.pop();
        if (action) {
            this.executing = true;
            const onDone = () => {
                this.executing = false;
                this.execute();
            };
            action().then(onDone).catch(onDone);
        }
    }
}
//# sourceMappingURL=queue.js.map